import { h } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";

import { Button, IconButton, Paper, Stack, TextField, Tooltip, Typography } from "@mui/material";


import { Box, FormControl } from "@mui/material";

import { useCookies } from "react-cookie";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { ValidateEmail, CheckTexVal, ValidatePwd } from "../Common/helpers";

export default function Mentored({ id }) {

    const [cookies, setCookie, removeCookie] = useCookies();
    const [values, setValues] = useState(
        { loaded: false }
    );
    const [disabled, setDisabled] = useState(
        false
    );
    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };

    useEffect(() => {
        setDisabled(ValidateEmail(values.email) &&
            CheckTexVal(values.fname) && CheckTexVal(values.lname) &&
            ValidatePwd(values.password) && (values.password === values.password2));
    }, [values]);
    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const submitSignin = () => {
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },

            body: JSON.stringify(values),
        };
        fetch("/anon/72884185f917437aa3d4f3989c75b0f7/" + id, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        setCookie("_bkeys", res.session_token, { path: "/" });
                        setCookie("_bkuser", res.name, { path: "/" });

                        window.location.replace("/dashboard");


                        break;
                    case "err":
                        //  app.refSnack.current.handleChangeState({ o: true, m: res.reason, s: "error" });
                        break;
                    default:
                        break;
                }
            });
    };
    useEffect(() => {
        removeCookie("_bkeys");
        removeCookie("_bkuser");
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch("/anon/45c938741a824155b9f26c1290dae80c/" + id, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":

                        setValues({ ...values, ...res.pld, loaded: true })

                        break;
                    case "err":
                        //  app.refSnack.current.handleChangeState({ o: true, m: res.reason, s: "error" });
                        break;
                    default:
                        break;
                }
            });

    }, []);
    if (!values.loaded) return;
    return (
        <Box style="min-height: 500px" display="flex" justifyContent="center" alignItems="center">
            <Paper elevation={3} style="width: 400px; padding: 10px;">
                <Stack spacing={1} >
                    <Typography variant="h5">{values.god_father} vous a parrainé{values.gender == 1 ? "e" : ""}</Typography>
                    <Typography variant="body1">Vérifez vos informations et mettez un mot de passe</Typography>

                    <FormControl variant="outlined" hiddenLabel>
                        <TextField
                            id="fname"
                            name="fname"
                            variant="outlined"
                            style={{
                                marginLeft: 0,
                                marginRight: 10,
                            }}
                            placeholder="Prénom"
                            fullWidth
                            margin="dense"
                            size="small"
                            value={values.fname}
                            onChange={handleChange("fname")}
                        />
                    </FormControl>
                    <FormControl variant="outlined" hiddenLabel>
                        <TextField
                            id="lname"
                            name="lname"
                            variant="outlined"
                            style={{
                                marginLeft: 0,
                                marginRight: 10,
                            }}
                            placeholder="Nom"
                            fullWidth
                            margin="dense"
                            size="small"
                            value={values.lname}
                            onChange={handleChange("lname")}
                        />
                    </FormControl>
                    <FormControl variant="outlined" hiddenLabel>
                        <TextField
                            id="email"
                            name="email"
                            variant="outlined"
                            style={{
                                marginLeft: 0,
                                marginRight: 10,
                            }}
                            placeholder="Email"
                            fullWidth
                            margin="dense"
                            size="small"
                            value={values.email}
                            onChange={handleChange("email")}
                        />
                    </FormControl>
                    <FormControl variant="outlined" hiddenLabel>
                        <Box display="flex" alignItems="center" justifyContent="space-between" p={1} m={1} style="padding: 0px; margin: 0px;">
                            <Box style="flex-grow: 1;">
                                <TextField
                                    id="password"
                                    name="password"
                                    variant="outlined"
                                    style={{
                                        marginLeft: 0,
                                        marginRight: 10,
                                    }}
                                    placeholder="Mot de passe (6 caractères min)"
                                    fullWidth
                                    margin="dense"
                                    size="small"
                                    value={values.password}
                                    onChange={handleChange("password")}

                                    type={values.showPassword ? "text" : "password"}
                                />
                            </Box>
                            <Box p={1}>
                                <Tooltip title={values.showPassword ? "Masquer le mot de passe" : "Voir le mot de passe"} aria-label="add">
                                    <IconButton aria-label="mot de passe " onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
                                        {values.showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Box>
                    </FormControl>
                    <FormControl variant="outlined" hiddenLabel>
                        <Box display="flex" alignItems="center" justifyContent="space-between" >
                            <Box style=" flex-grow: 1;">
                                <TextField
                                    id="password2"
                                    name="password2"
                                    variant="outlined"
                                    style={{
                                        marginLeft: 0,
                                        marginRight: 10,
                                    }}
                                    placeholder="Confirmation du mot de passe (6 caractères min)"
                                    fullWidth
                                    margin="dense"
                                    size="small"
                                    value={values.password2}
                                    onChange={handleChange("password2")}

                                    type={values.showPassword ? "text" : "password"}
                                />
                            </Box>
                        </Box>
                    </FormControl>
                    <Button
                        variant="contained"
                        onClick={submitSignin}
                        disabled={!disabled}
                    >M'inscrire</Button>
                </Stack>
            </Paper>
        </Box>
    );
}
